import React from "react";
import Header from "../../layout/Header/Header";

const SinPermiso = ({ que = "esta pantalla" }) => (
  <>
    <Header />
    <div className="card container col-12" style={{ padding: "24px" }}>
      <div className="alert alert-warning mb-0"><i className="fas fa-lock mr-2" />No tienes permiso para {que}. Pídelo a quien administra los usuarios.</div>
    </div>
  </>
);

export default SinPermiso;
